import React from 'react'
import Alert from 'react-bootstrap/Alert'

function Notifier({ message }) {
  return <Alert variant='danger'>{message}</Alert>
}

export default Notifier
